const styles = theme => {
    return ({
    emptyText: {
        margin: "50px 0 50px 0",
        color: "#c5c5c5"
    },
  });
  }
  
  export default styles;